"use client";
import React, { useState } from "react";
import Link from "next/link";

export default function Metrics({ lang = 'vn' }: { lang?: 'vn' | 'en' }) {
  const [activePopup, setActivePopup] = useState<string | null>(null);

  const togglePopup = (id: string) => {
    setActivePopup(activePopup === id ? null : id);
  };

  return (
    <>
<div className="div-block-89">
 <div className="section-mvp">
  <div className="container-small">
   <div className="product_container data-container">
    <h2 className="product_heading-2" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7d9" >
     {lang === 'vn' ? 'Trải nghiệm Phân tích theo thời gian thực OmniEdge AI' : 'Experience OmniEdge AI Real-Time Analytics'}
    </h2>
    <h4 className="product-headfng-two-2" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7db" >
     {lang === 'vn' ? 'Chuyển đổi các camera CCTV tiêu chuẩn thành hệ thống giám sát phân tích chủ động, thời gian thực tại biên thông qua phần cứng phân tán với chi phí cực thấp.' : 'Transform standard CCTV cameras into proactive, real-time edge monitoring systems through ultra-low-cost distributed edge hardware.'}
    </h4>
     <a className="button-secondary w-button" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7dd" href="mailto:contact@keeneyeai.site" style={{ background: "linear-gradient(135deg, #6366f1, #4f46e5)", border: "none", color: "#fff", padding: "12px 24px", borderRadius: "8px" }} >
      {lang === 'vn' ? 'Nhận báo giá tùy chỉnh' : 'Get a Custom Proposal'}
     </a>
    <img alt="" className="image-81" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7df" loading="lazy" sizes="100vw" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afe4_Group%202147257445%20(1).avif" srcSet="
                  https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afe4_Group%25202147257445%2520(1)-p-500.avif   500w,
                  https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afe4_Group%25202147257445%2520(1)-p-800.avif   800w,
                  https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afe4_Group%25202147257445%2520(1)-p-1080.avif 1080w,
                  https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afe4_Group%25202147257445%2520(1)-p-1600.avif 1600w,
                  https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afe4_Group%202147257445%20(1).avif            2256w
                " />
   </div>
    <div className="hero-numbers-wrapper">
     <h2 className="outcome_heading-2 assitance-head" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7e1" >
      {lang === 'vn' ? 'Hiệu Suất Vượt Trội' : 'High-Performance'}
      <br/>
      {lang === 'vn' ? 'Của Edge AI' : 'Edge AI Metrics'}
     </h2>
    </div>
  </div>
  <img alt="" className="map" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b92d_Group%201597883734.png"/>
  <img alt="" className="mvp-gradient" loading="lazy" sizes="100vw" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afc6_Group%201597883807.avif" srcSet="
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afc6_Group%25201597883807-p-500.avif   500w,
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afc6_Group%25201597883807-p-800.avif   800w,
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afc6_Group%25201597883807-p-1080.avif 1080w,
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afc6_Group%25201597883807-p-1600.avif 1600w,
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afc6_Group%25201597883807-p-2000.avif 2000w,
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9afc6_Group%201597883807.avif          3996w
            "/>
  <div className="container-small padding-top-none">
    <div className="numbers-wrapper">
     <div className="number-main-2" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "24px", width: "100%" }}>
      <div 
        className="number-one-2 iris-outline" 
        data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7ea"
        style={{
          background: "rgba(255, 255, 255, 0.02)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
          borderRadius: "20px",
          padding: "48px 32px",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
          e.currentTarget.style.borderColor = "rgba(16, 185, 129, 0.4)";
          e.currentTarget.style.boxShadow = "0 20px 40px rgba(16, 185, 129, 0.2)";
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.04)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0) scale(1)";
          e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.08)";
          e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.2)";
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.02)";
        }}
      >
       <h1 className="number-text-2 iris" style={{
         background: "linear-gradient(135deg, #34d399 0%, #10b981 50%, #059669 100%)",
         WebkitBackgroundClip: "text",
         WebkitTextFillColor: "transparent",
         backgroundImage: "linear-gradient(135deg, #34d399 0%, #10b981 50%, #059669 100%)",
         fontSize: "4.5rem",
         fontWeight: "800",
         margin: "0 0 12px 0",
         letterSpacing: "-2px"
       }}>
        75%+
       </h1>
       <p className="number-line-2 light" style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "1.1rem", margin: 0, fontWeight: "500" }}>
        {lang === 'vn' ? 'Lợi nhuận gộp SaaS cho đối tác B2B' : 'Gross SaaS Margin for B2B Partners'}
       </p>
      </div>

      <div 
        className="number-two-2" 
        data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7ef"
        style={{
          background: "rgba(255, 255, 255, 0.02)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
          borderRadius: "20px",
          padding: "48px 32px",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
          e.currentTarget.style.borderColor = "rgba(99, 102, 241, 0.4)";
          e.currentTarget.style.boxShadow = "0 20px 40px rgba(99, 102, 241, 0.2)";
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.04)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0) scale(1)";
          e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.08)";
          e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.2)";
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.02)";
        }}
      >
       <h1 className="number-text-2 iris" style={{
         background: "linear-gradient(135deg, #818cf8 0%, #6366f1 50%, #4f46e5 100%)",
         WebkitBackgroundClip: "text",
         WebkitTextFillColor: "transparent",
         backgroundImage: "linear-gradient(135deg, #818cf8 0%, #6366f1 50%, #4f46e5 100%)",
         fontSize: "4.5rem",
         fontWeight: "800",
         margin: "0 0 12px 0",
         letterSpacing: "-2px"
       }}>
        ₫5.0M
       </h1>
       <p className="number-line-2 light" style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "1.1rem", margin: 0, fontWeight: "500" }}>
        {lang === 'vn' ? 'Chi phí thiết lập NPU Node 1 lần' : 'One-time Edge NPU Node Setup'}
       </p>
      </div>

      <div 
        className="number-three-2" 
        data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7f4"
        style={{
          background: "rgba(255, 255, 255, 0.02)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
          borderRadius: "20px",
          padding: "48px 32px",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
          e.currentTarget.style.borderColor = "rgba(244, 114, 182, 0.4)";
          e.currentTarget.style.boxShadow = "0 20px 40px rgba(244, 114, 182, 0.2)";
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.04)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0) scale(1)";
          e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.08)";
          e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.2)";
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.02)";
        }}
      >
       <h1 className="number-text-2 iris" style={{
         background: "linear-gradient(135deg, #f472b6 0%, #ec4899 50%, #db2777 100%)",
         WebkitBackgroundClip: "text",
         WebkitTextFillColor: "transparent",
         backgroundImage: "linear-gradient(135deg, #f472b6 0%, #ec4899 50%, #db2777 100%)",
         fontSize: "4.5rem",
         fontWeight: "800",
         margin: "0 0 12px 0",
         letterSpacing: "-2px"
       }}>
        &lt;100ms
       </h1>
       <p className="number-line-2 light" style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "1.1rem", margin: 0, fontWeight: "500" }}>
        {lang === 'vn' ? 'Độ trễ xử lý cục bộ thời gian thực' : 'Real-time Local Processing Latency'}
       </p>
      </div>
     </div>
    </div>
   <div className="popup-image-div-2">
    <img alt="" className="pop-up-image desktop-only" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/66334d8b6b8fd80cf5d65b25_homepage-camera_system%402x-min.png" width="1140"/>
    <img alt="" className="pop-up-image phone-only" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/670e43edabb4626493f60f64_product-mobile.png" width="1140"/>
    <img alt="" className="phone-expand-icon _1" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7fc" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b24b_ivr-mobile.svg"/>
    <img alt="" className="phone-expand-icon _2" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7fd" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b24b_ivr-mobile.svg"/>
    <img alt="" className="phone-expand-icon _3" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7fe" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b24b_ivr-mobile.svg"/>
    <div className="prompt-data for-phone" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7ff">
     <p className="prompt-data-heading">
      {lang === 'vn' ? 'Camera IP' : 'IP Cameras'}
     </p>
     <p className="prompt-data-para">
      {lang === 'vn' ? 'Camera độ phân giải cao, tuân thủ NDAA miễn phí cho bạn. Hoặc bạn có thể giữ nguyên camera hiện tại. Tùy thuộc vào bạn.' : 'Premium, high resolution, NDAA compliant cameras at no cost to you. Or, you can keep your current cameras. It’s up to you.'}
     </p>
     <a className="link-block-7 top-margin-10px w-inline-block" href="#">
      <div className="text-block-45 prompt-data-link">
       {lang === 'vn' ? 'Tìm hiểu thêm' : 'Learn more'}
      </div>
      <img alt="" className="image-80 changed-width-and-height" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6af7d_Arrow%202%402x.png"/>
     </a>
     <img alt="" className="popup-cross" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b2a2_close.svg"/>
    </div>
    <div className="prompt-data for-phone" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f809">
     <p className="prompt-data-heading">
      {lang === 'vn' ? 'Bảng điều khiển Cloud' : 'Cloud Dashboard'}
     </p>
     <p className="prompt-data-para">
      {lang === 'vn' ? 'Xem các vị trí từ một bảng điều khiển, tìm kiếm và giải quyết sự cố trong vài phút, và biến thông tin thành hành động.' : 'View locations from one dashboard, search and resolve incidents in minutes, and turn insights into actions.'}
     </p>
     <a className="link-block-7 top-margin-10px w-inline-block" href="#">
      <div className="text-block-45 prompt-data-link">
       Learn more
      </div>
      <img alt="" className="image-80 changed-width-and-height" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6af7d_Arrow%202%402x.png"/>
     </a>
     <img alt="" className="popup-cross" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b2a2_close.svg"/>
    </div>
    <div className="prompt-data for-phone" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f813">
     <p className="prompt-data-heading">
      {lang === 'vn' ? 'Đầu ghi Video Thông minh' : 'Intelligent Video Recorder'}
     </p>
     <p className="prompt-data-para">
      {lang === 'vn' ? 'Lưu trữ cục bộ 24x7, được tăng cường sức mạnh với xử lý AI tại biên, thiết lập trong vài phút, có thể mở rộng cho bất kỳ số lượng camera nào.' : '24x7 local storage, supercharged with on-edge AI processing, sets up in minutes, scales to any number of cameras.'}
     </p>
     <a className="link-block-7 top-margin-10px w-inline-block" href="#">
      <div className="text-block-45 prompt-data-link">
       Learn more
      </div>
      <img alt="" className="image-80 changed-width-and-height" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6af7d_Arrow%202%402x.png"/>
     </a>
     <img alt="" className="popup-cross" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b2a2_close.svg"/>
    </div>
    <div className="image-prompt-holder _1">
     <div className="image-prompt-heading-2 relative" onClick={() => togglePopup('ivr')} style={{ cursor: 'pointer' }} >
      <img alt="" className="expand-icon" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b248_expandIcon.svg" style={{ transform: activePopup === 'ivr' ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }}/>
      <div className="pulse_animation" style={{ display: activePopup === 'ivr' ? 'none' : 'block' }}>
      </div>
      <p className="prompt-heading">
       {lang === 'vn' ? 'Đầu ghi Video Thông minh' : 'Intelligent Video Recorder'}
      </p>
     </div>
     <div className="image-prompt-wrapper opens-upwards z-index--1" style={{ opacity: activePopup === 'ivr' ? 1 : 0, visibility: activePopup === 'ivr' ? 'visible' : 'hidden', transform: activePopup === 'ivr' ? 'translateY(0)' : 'translateY(10px)', transition: 'all 0.3s ease', pointerEvents: activePopup === 'ivr' ? 'auto' : 'none', position: 'absolute', bottom: '100%' }}>
      <div className="prompt-data" style={{ display: 'block' }}>
       <p className="prompt-data-heading">
        {lang === 'vn' ? 'Đầu ghi Video Thông minh' : 'Intelligent Video Recorder'}
       </p>
       <p className="prompt-data-para">
        {lang === 'vn' ? 'Lưu trữ cục bộ 24/7, được tăng cường sức mạnh với xử lý AI tại biên, thiết lập trong vài phút, có thể mở rộng cho bất kỳ số lượng camera nào.' : '24/7 local storage, supercharged with on-edge AI processing, sets up in minutes, scales to any number of cameras.'}
       </p>
       <img alt="" className="popup-cross" onClick={(e) => { e.stopPropagation(); togglePopup('ivr'); }} loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b2a2_close.svg" style={{ cursor: 'pointer' }}/>
       <a className="link-block-7 top-margin-10px w-inline-block" href="#">
        <div className="text-block-45 prompt-data-link">
         Learn more
        </div>
        <img alt="" className="image-80 changed-width-and-height" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6af7d_Arrow%202%402x.png"/>
       </a>
      </div>
     </div>
    </div>
    <div className="image-prompt-holder _2">
     <div className="image-prompt-wrapper z-index-1">
      <div className="image-prompt-heading-2 relative" onClick={() => togglePopup('cameras')} style={{ cursor: 'pointer' }}>
       <img alt="" className="expand-icon" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b248_expandIcon.svg" style={{ transform: activePopup === 'cameras' ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }}/>
       <div className="pulse_animation" style={{ display: activePopup === 'cameras' ? 'none' : 'block' }}>
       </div>
       <p className="prompt-heading">
        {lang === 'vn' ? 'Camera IP' : 'IP Cameras'}
       </p>
      </div>
      <div className="prompt-data" style={{ opacity: activePopup === 'cameras' ? 1 : 0, visibility: activePopup === 'cameras' ? 'visible' : 'hidden', transform: activePopup === 'cameras' ? 'translateY(0)' : 'translateY(-10px)', transition: 'all 0.3s ease', pointerEvents: activePopup === 'cameras' ? 'auto' : 'none', position: 'absolute', top: '100%', zIndex: 10 }}>
       <p className="prompt-data-heading">
        {lang === 'vn' ? 'Camera IP' : 'IP Cameras'}
       </p>
       <p className="prompt-data-para">
        {lang === 'vn' ? 'Nhận camera độ phân giải cao, tuân thủ NDAA miễn phí. Thêm camera chuyên dụng như PTZ hoặc fisheye khi cần. Hoặc giữ nguyên camera hiện tại. Tùy bạn.' : 'Get high-resolution, NDAA-compliant cameras at no cost to you. Add on specialty cameras like PTZ or fisheye as needed. Or keep your current cameras. It’s up to you.'}
       </p>
       <a className="link-block-7 top-margin-10px w-inline-block" href="#">
        <div className="text-block-45 prompt-data-link">
         Learn more
        </div>
        <img alt="" className="image-80 changed-width-and-height" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6af7d_Arrow%202%402x.png"/>
       </a>
       <img alt="" className="popup-cross" onClick={(e) => { e.stopPropagation(); togglePopup('cameras'); }} loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b2a2_close.svg" style={{ cursor: 'pointer' }}/>
      </div>
     </div>
    </div>
    <div className="image-prompt-holder _3">
     <div className="image-prompt-wrapper">
      <div className="image-prompt-heading-2 relative" onClick={() => togglePopup('cloud')} style={{ cursor: 'pointer' }} >
       <img alt="" className="expand-icon" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b248_expandIcon.svg" style={{ transform: activePopup === 'cloud' ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }}/>
       <div className="pulse_animation" style={{ display: activePopup === 'cloud' ? 'none' : 'block' }}>
       </div>
       <p className="prompt-heading">
        {lang === 'vn' ? 'Bảng điều khiển Cloud' : 'Cloud Dashboard'}
       </p>
      </div>
      <div className="prompt-data" style={{ opacity: activePopup === 'cloud' ? 1 : 0, visibility: activePopup === 'cloud' ? 'visible' : 'hidden', transform: activePopup === 'cloud' ? 'translateY(0)' : 'translateY(-10px)', transition: 'all 0.3s ease', pointerEvents: activePopup === 'cloud' ? 'auto' : 'none', position: 'absolute', top: '100%', zIndex: 10 }}>
       <p className="prompt-data-heading">
        {lang === 'vn' ? 'Bảng điều khiển Cloud' : 'Cloud Dashboard'}
       </p>
       <p className="prompt-data-para">
        {lang === 'vn' ? 'Xem các vị trí từ một bảng điều khiển, tìm kiếm và giải quyết sự cố trong vài phút, và biến thông tin thành hành động.' : 'View locations from one dashboard, search and resolve incidents in minutes, and turn insights into actions.'}
       </p>
       <a className="link-block-7 top-margin-10px w-inline-block" href="#">
        <div className="text-block-45 prompt-data-link">
         Learn more
        </div>
        <img alt="" className="image-80 changed-width-and-height" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6af7d_Arrow%202%402x.png"/>
       </a>
       <img alt="" className="popup-cross" onClick={(e) => { e.stopPropagation(); togglePopup('cloud'); }} loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b2a2_close.svg" style={{ cursor: 'pointer' }}/>
      </div>
     </div>
    </div>
    <div className="pulse_animation _1" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f850" id="pulseanimation-1">
    </div>
    <div className="pulse_animation _3" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f851" id="pulseanimation-3">
    </div>
    <div className="pulse_animation _2" data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f852" id="pulseanimation-2">
    </div>
   </div>
  </div>
 </div>
</div>

    </>
  );
}
